import {
	forwardRef,
	PropsWithChildren,
	ReactElement,
	Ref
} from "react";
import { Icon } from "../Icon/Icon";
import classNames from "classnames";
import styles from "./PreviousNextSlider.module.less";
import { setTrackingId, generateTrackingId } from "client/Misc/utils";
import { ButtonBase } from "../ButtonBase/ButtonBase";
import { localize } from "client_legacy/ndaw/culture";

export type PreviousNextSliderSize = "normal" | "large";

export type PreviousNextSliderProps = {
	onPrevious(): void;
	onNext(): void;
	onLabel?(): void;
	trackingId?: string;
	size?: PreviousNextSliderSize;
};

export const PreviousNextSlider = forwardRef<HTMLDivElement, PropsWithChildren<PreviousNextSliderProps>>(
	(props: PropsWithChildren<PreviousNextSliderProps>, ref: Ref<HTMLDivElement>): ReactElement => {
		const {
			onPrevious,
			onNext,
			onLabel,
			children,
			trackingId,
			size = "normal"
		} = props;

		return (
			<div
				ref={ref}
				className={classNames(
					styles.root,
					{[styles.root_large]: size === "large"}
				)}
			>
				<div className={styles.content}>
					<button
						{...setTrackingId(trackingId, "__previous-button")}
						className={styles.button}
						onClick={onPrevious}
						aria-label={localize("_Previous")}
					>
						<Icon value="chevron-left" />
					</button>
					<ButtonBase
						trackingId={generateTrackingId(trackingId, "__label")}
						className={styles.label}
						onClick={onLabel}
						disabled={!onLabel}
					>
						{ children }
					</ButtonBase>
					<button
						{...setTrackingId(trackingId, "__next-button")}
						className={styles.button}
						onClick={onNext}
						aria-label={localize("_Next")}
					>
						<Icon value="chevron-right" />
					</button>
				</div>
			</div>
		);
	}
);
PreviousNextSlider.displayName = "PreviousNextSlider";
